import Navbar from "@/components/Navbar";
import { AppLayout } from "@/components/layout/AppLayout";
import { PageContainer } from "@/components/layout/PageContainer";
import { SimpleIssuesInbox } from "@/components/owner/SimpleIssuesInbox";

/** Slice 7 — owner Issues inbox (cross-property). */
const IssuesInbox = () => {
  return (
    <AppLayout>
      <Navbar />
      <PageContainer className="py-5 sm:py-6">
        <SimpleIssuesInbox />
      </PageContainer>
    </AppLayout>
  );
};

export default IssuesInbox;
